import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Dialog, IconButton, Button, Checkbox } from 'react-toolbox';
import swal from 'sweetalert';
import { fetchPhaseDocuments, woReportSubmissionCreate } from 'actionCreators';
import PhaseType from 'types/phase';
import documentUploadShape from 'types/documentUpload';
import RTCheckbox from 'styles/checkbox.scss';
import modalStyles from 'modal.scss';
import { EXTERNAL_REPORT_NAME, woReportPhotos } from './woReportUtils';
import S from './submitWoReportModal.scss';

const WARNING = `ATTENTION: This will upload the ${EXTERNAL_REPORT_NAME} and ALL selected ` +
  'photos to Vendor Gateway';

const errorMessageFrom = (error) => {
  const errors = (error || {}).errors;
  if (!errors) return '';
  if (typeof errors === 'string') return errors;
  if (Array.isArray(errors.messages)) return errors.messages[0];
  const key = Object.keys(errors)[0];
  const value = key ? errors[key] : null;
  if (Array.isArray(value)) return `${key} ${value[0]}`;
  return typeof value === 'string' ? `${key} ${value}` : '';
};

class SubmitWoReportModal extends React.Component {
  state = { selectedIds: [], loading: false, errorMessage: '' }

  componentDidUpdate(prevProps) {
    if (this.props.active && !prevProps.active) {
      // Reset the selection and pick up any photos added since the page loaded.
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedIds: [], loading: false, errorMessage: '' });
      this.props.fetchPhaseDocuments(this.props.phase.id);
    }
  }

  handleClose = () => {
    if (!this.state.loading) this.props.onClose();
  }

  handleToggle = photoId => () => this.setState({ selectedIds: this.toggled(photoId) });

  toggled = (photoId) => {
    const { selectedIds } = this.state;
    if (selectedIds.includes(photoId)) return selectedIds.filter(id => id !== photoId);
    return [...selectedIds, photoId];
  }

  handleSubmit = () => {
    const { selectedIds } = this.state;
    this.setState({ loading: true, errorMessage: '' });
    this.props.woReportSubmissionCreate({
      phase_id: this.props.phase.id,
      photo_ids: selectedIds,
    })
      .then(() => {
        this.setState({ loading: false });
        this.props.onClose();
        return this.showSuccessAlert(selectedIds.length);
      })
      .catch(error => this.setState({
        loading: false,
        errorMessage: errorMessageFrom(error) ||
          'Unable to submit the WO report. Please retry.',
      }));
  }

  showSuccessAlert = photoCount => swal({
    title: 'Submitted!',
    text: `The ${EXTERNAL_REPORT_NAME} and ${photoCount} photo(s) are being uploaded to Vendor Gateway.`,
    icon: 'success',
    buttons: false,
    timer: 4000,
  })

  renderPhoto = photo => (
    <div className={S.photo} key={photo.id}>
      <Checkbox
        checked={this.state.selectedIds.includes(photo.id)}
        label={photo.document_name}
        onChange={this.handleToggle(photo.id)}
        theme={RTCheckbox}
      />
      <img
        className={S.thumbnail}
        src={photo.expiring_download_url}
        alt={photo.document_name}
      />
    </div>
  )

  render = () => {
    const { active, photos } = this.props;
    const { loading, errorMessage } = this.state;
    return (<Dialog
      active={active}
      className={modalStyles.modal}
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <IconButton icon="close" className={modalStyles.close} onClick={this.handleClose} />
      <h5>Submit Workorder Inspection Report to Lowe&apos;s</h5>
      <div className={S.warning} role="alert">{WARNING}</div>
      {errorMessage && <div className={S.error} role="alert">{errorMessage}</div>}
      <p className={S.message}>Select which photos to include</p>
      {photos.length > 0 ?
        <div className={S.photoList}>{photos.map(this.renderPhoto)}</div> :
        <p className={S.empty}>This phase has no photos to include.</p>}
      <div className={S.actions}>
        <Button label="Cancel" flat onClick={this.handleClose} disabled={loading} />
        <Button
          label={loading ? 'Submitting...' : "Submit to Lowe's"}
          primary
          raised
          onClick={this.handleSubmit}
          disabled={loading}
        />
      </div>
    </Dialog>);
  }
}

SubmitWoReportModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  photos: PropTypes.arrayOf(documentUploadShape).isRequired,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  woReportSubmissionCreate: PropTypes.func.isRequired,
};

SubmitWoReportModal.defaultProps = { active: false };

export default connect(
  state => ({ photos: woReportPhotos(state.phase.documents.data) }),
  { fetchPhaseDocuments, woReportSubmissionCreate },
)(SubmitWoReportModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/submitWoReportModal.jsx